import React, { useState, useEffect } from 'react';
import { Calculator, TrendingUp } from 'lucide-react';

const NAMES = ['Maria', 'Ana', 'Francisca', 'João', 'José', 'Antônio'];

const MockupApp: React.FC = () => {
  const [currentNameIndex, setCurrentNameIndex] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentName = NAMES[currentNameIndex];
    const typingSpeed = isDeleting ? 50 : 150;
    const pauseDuration = 2000;

    const timeout = setTimeout(() => {
      if (!isDeleting) {
        setDisplayText(currentName.substring(0, displayText.length + 1));
        if (displayText.length === currentName.length) {
          setTimeout(() => setIsDeleting(true), pauseDuration);
        }
      } else {
        setDisplayText(currentName.substring(0, displayText.length - 1));
        if (displayText.length === 0) {
          setIsDeleting(false);
          setCurrentNameIndex((prev) => (prev + 1) % NAMES.length);
        }
      }
    }, typingSpeed);

    return () => clearTimeout(timeout);
  }, [displayText, isDeleting, currentNameIndex]);

  return (
    <div className="absolute inset-0 bg-[#f8f9fa] flex flex-col p-4 pt-10 font-sans">
      {/* App Header */}
      <div className="flex justify-between items-start mb-8">
        <div className="bg-white p-1 shadow-sm rounded">
          <div className="text-[10px] font-bold text-[#1e293b] flex items-center gap-0.5">
            <span className="text-emerald-600">R</span>
            <span className="text-[6px] align-top">MAX</span>
          </div>
        </div>
        <div className="bg-white border border-slate-200 rounded-full px-2 py-0.5 flex items-center gap-1 shadow-sm">
          <div className="w-2.5 h-2.5 bg-slate-100 rounded flex items-center justify-center">
            <div className="w-1.5 h-1.5 border border-slate-400 rounded-xs"></div>
          </div>
          <span className="text-[7px] font-bold text-slate-600 uppercase tracking-tighter">Instalações e Reparos</span>
        </div>
      </div>

      {/* Welcome Message */}
      <h2 className="text-lg font-black mb-8 tracking-tight">
        <span className="text-black">Olá!</span> <span className="text-emerald-600 border-r-2 border-emerald-600/30 pr-0.5">{displayText}</span>
      </h2>

      {/* Grid of Actions */}
      <div className="grid grid-cols-2 gap-3 mb-auto">
        <div className="bg-white rounded-2xl p-4 shadow-sm border border-emerald-50/50 flex flex-col items-center text-center">
          <div className="w-10 h-10 bg-emerald-50 rounded-xl flex items-center justify-center mb-3">
            <Calculator className="w-5 h-5 text-emerald-600" />
          </div>
          <span className="text-[8px] font-black text-[#1a1a1a] leading-tight uppercase">Novo<br/>Orçamento</span>
        </div>

        <div className="bg-white rounded-2xl p-4 shadow-sm border border-slate-50 flex flex-col items-center text-center">
          <div className="w-10 h-10 bg-slate-50 rounded-xl flex items-center justify-center mb-3">
            <div className="grid grid-cols-2 gap-0.5">
              <div className="w-1.5 h-1.5 bg-slate-800 rounded-xs"></div>
              <div className="w-1.5 h-1.5 bg-slate-800 rounded-xs"></div>
              <div className="w-1.5 h-1.5 bg-slate-800 rounded-xs"></div>
              <div className="w-1.5 h-1.5 bg-slate-800 rounded-xs"></div>
            </div>
          </div>
          <span className="text-[8px] font-black text-[#1a1a1a] leading-tight uppercase">Gerir<br/>Orçamentos</span>
        </div>

        <div className="bg-white rounded-2xl p-4 shadow-sm border border-slate-50 flex flex-col items-center text-center">
          <div className="w-10 h-10 bg-slate-50 rounded-xl flex items-center justify-center mb-3 overflow-hidden">
            <div className="w-6 h-6 bg-[#0f172a] rounded-full flex items-center justify-center">
              <TrendingUp className="w-3 h-3 text-orange-500" />
            </div>
          </div>
          <span className="text-[8px] font-black text-[#1a1a1a] leading-tight uppercase">Meu<br/>Cadastro</span>
        </div>

        <div className="bg-white rounded-2xl p-4 shadow-sm border border-orange-50/50 flex flex-col items-center text-center">
          <div className="w-10 h-10 bg-orange-50 rounded-xl flex items-center justify-center mb-3">
            <div className="w-5 h-5 border-2 border-orange-500 rounded-sm relative">
              <div className="absolute top-0 left-0 w-full h-0.5 bg-orange-500"></div>
            </div>
          </div>
          <span className="text-[8px] font-black text-[#1a1a1a] leading-tight uppercase">Centro de<br/>Custos</span>
        </div>
      </div>

      <div className="mt-auto pb-4 text-center">
        <p className="text-[6px] font-bold text-slate-300 uppercase tracking-widest">Powered by R MAX Intelligence</p>
      </div>
    </div>
  );
};

export default React.memo(MockupApp);
